export type CounselingCategory = "매수신청대리인" | "매물컨설팅" | "임장동행" | "중개";

export type OfficeInfo = {
  name?: string;
  ceo?: string;
  registrationNumber?: string;
  type?: string;
  phone?: string;
  address?: string;
  pnu?: string;
};

export type ExpertInfo = {
  expertNo: number;
  profile: string; // 최상위 프로필 이미지 URL
  updatedAt: string; // 최상위 updatedAt
  info: {
    phone: string;
    officeInfo?: OfficeInfo;
    counselingCategories: CounselingCategory[];
    career: {
      [key in CounselingCategory]?: number | string;
    };
    qualification?: string | null;
    introduction?: string | null;
    auctionAgentCertFileUrl?: string;
    updatedAt: string; // info 내부 updatedAt
    bankName?: string;
    bankAccount?: string;
    type: string;
    file?: {
      url: string; // 프로필 이미지 URL (백업용)
    };
  };
};

// * 전문가 정보 수정
export type UpdateExpertInfo = {
  expertNo: number;
  phone: string;
  profile: string;
  officeInfo: {
    name: string;
    ceo: string;
    registrationNumber?: string;
    type?: string;
    phone: string;
    address: string;
    pnu?: string;
  };
  counselingCategories: CounselingCategory[];
  career: {
    [key: string]: number; 
  };
  qualification: string;
  introduction: string;
  isAuctionAgent: boolean;
  auctionAgentCertFileUrl?: string;
  bankName: string;
  bankAccount: string;
}

export type ExpertApprovalStatus = {
  isAuctionAgent: boolean;
  isApproved: boolean;
  isRejected: boolean;
};

import { axiosInstance } from "@src/api/axiosConfig";
import { expertJoinPath } from "./expertApiConfig";
import { axiosPath } from "@src/api/axiosPath";

// 전문가 정보 조회
export const getExpertInfo = async (): Promise<ExpertInfo> => {
  const res = await axiosInstance.get<ExpertInfo>(axiosPath.expertInfo);
  return res.data;
};

// 전문가 정보 수정
export const updateExpertInfo = async (
  body: UpdateExpertInfo
): Promise<string | ExpertInfo> => {
  const res = await axiosInstance.put(axiosPath.expertUpdate, body);
  const data = res.data;
  if (typeof data === "string") return data;
  return data;
};

export async function uploadExpertProfileImage(file: File, isTemp: boolean = true): Promise<string> {
    const formData = new FormData();
    formData.append("profile", file);
    formData.append("isTemp", isTemp.toString());
    const res = await axiosInstance.put(expertJoinPath.uploadProfileImage, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data.url;
}

export const getExpertApprovalStatus = async (): Promise<ExpertApprovalStatus> => {
  const res = await axiosInstance.get<ExpertApprovalStatus>(axiosPath.expertApproveCheck);
  return res.data;
};


